import styled from 'styled-components'

export const UnstyledButton = styled.button`
  :hover {
    background-color: unset;
  }
  background-color: unset;
  border: none;
  align-items: center;
  padding: 0px;
  display: flex;
  cursor: pointer;
`
